import { render, staticRenderFns } from "./ProjectsPage2.vue?vue&type=template&id=6eebf292&lang=pug&"
import script from "./ProjectsPage2.vue?vue&type=script&lang=js&"
export * from "./ProjectsPage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports